<template>
    <div class="" v-if="inputVal">
        <student-worksheet-module-wrapper
            :module="module"
            :module-complete="response.module_complete"
            :worksheet-complete="worksheetComplete"
        >
            <div class="px-8">
                <textarea
                    class="w-full rounded border border-gray-200 bg-gray-100 p-4 text-[18px] text-gray-800 outline-none placeholder:text-gray-550"
                    v-model="response.text"
                    placeholder="Enter your answer"
                    rows="6"
                ></textarea>
            </div>
        </student-worksheet-module-wrapper>
    </div>
</template>

<script>
import StudentWorksheetModuleWrapper from "@/Components/StudentWorksheetModuleWrapper";

export default {
    name: "StudentWorksheetModuleText",
    components: {
        StudentWorksheetModuleWrapper,
    },
    props: ["modelValue", "module", "worksheetComplete"],
    data() {
        return {
            response: {},
        };
    },
    mounted() {
        if (!this.modelValue) {
            this.response = {
                text: "",
                module_complete: false,
            };
        } else {
            this.response = {
                text: this.modelValue.text,
                module_complete: this.modelValue.module_complete,
            };
        }

        this.inputVal = this.response;
    },
    watch: {
        "response.text": function (newValue, oldValue) {
            if (newValue) {
                this.response.text = newValue;
                this.response.module_complete = true;
            }

            this.inputVal = this.response;
        },
    },
    computed: {
        inputVal: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit("update:modelValue", val);
            },
        },
    },
};
</script>

<style scoped></style>
